import { NgModule } from '@angular/core'

import { VideoModalComponent } from './video-modal.component'
import { MbI18nModule } from '../../../../translations/mb-i18n.module'
import { SafeHtmlModule } from '../../../pipes/sanitize-html/safe-html.module'
import { CommonModule } from '@angular/common'
import { CmsDirectivesModule } from '../../../directives/cms-directives.module'

@NgModule({
  declarations: [
    VideoModalComponent
  ],
  imports: [
    MbI18nModule,
    SafeHtmlModule,
    CommonModule,
    CmsDirectivesModule,
  ],
  exports: [
    VideoModalComponent
  ]
})
export class VideoModalModule {
}
